
import { FAQSection } from "./FAQSection";

interface MemberFAQSectionProps {
  organizationId: string;
  sectionId: string;
}

export const MemberFAQSection = ({ organizationId, sectionId }: MemberFAQSectionProps) => {
  return <FAQSection organizationId={organizationId} sectionId={sectionId} isAdmin={false} />;
};
